import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS } from "@tCentro/theme/design";
import * as React from "react";
import { css } from "styled-components";

export interface CustomCircleInfoIconStyles {
    infoIcon?: InjectableCss;
}

export const customCircleInfoIcon: CustomCircleInfoIconStyles = {
    infoIcon: {
        css: css`
            width: 16px;
            svg {
                height: 16px !important;
                width: 16px !important;
            }
        `,
    },
};

const styles = customCircleInfoIcon;

const CustomCircleInfoIcon: React.FC = () => {
    return (
        <StyledWrapper {...styles.infoIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                    d="M8 2C4.68594 2 2 4.68594 2 8C2 11.3141 4.68594 14 8 14C11.3141 14 14 11.3141 14 8C14 4.68594 11.3141 2 8 2ZM8 5C8.41414 5 8.75 5.33586 8.75 5.75C8.75 6.16414 8.41414 6.5 8 6.5C7.58586 6.5 7.25 6.16484 7.25 5.75C7.25 5.33516 7.58516 5 8 5ZM8.9375 11H7.0625C6.75313 11 6.5 10.7492 6.5 10.4375C6.5 10.1258 6.75195 9.875 7.0625 9.875H7.4375V8.375H7.25C6.93945 8.375 6.6875 8.12305 6.6875 7.8125C6.6875 7.50195 6.94063 7.25 7.25 7.25H8C8.31055 7.25 8.5625 7.50195 8.5625 7.8125V9.875H8.9375C9.24805 9.875 9.5 10.127 9.5 10.4375C9.5 10.748 9.24922 11 8.9375 11Z"
                    fill="white"
                />
            </svg>
        </StyledWrapper>
    );
};

export default React.memo(CustomCircleInfoIcon);
